import React from 'react';

interface SimpleBadgeProps {
  children: React.ReactNode;
  className?: string;
}

export const SimpleBadge: React.FC<SimpleBadgeProps> = ({ children, className = '' }) => {
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${className}`}>
      {children}
    </span>
  );
};

export default SimpleBadge; 